import { render, staticRenderFns } from "./goods_import.vue?vue&type=template&id=3a2c37bc&scoped=true&"
import script from "./goods_import.vue?vue&type=script&lang=ts&"
export * from "./goods_import.vue?vue&type=script&lang=ts&"
import style0 from "./goods_import.vue?vue&type=style&index=0&id=3a2c37bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2c37bc",
  null
  
)

export default component.exports